import { toWSDateString } from "@wingspanhq/fe-component-library";
import {
  IPayeeResponse,
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { useMutationDownloadPayeeW9 } from "../../../../../../query/payee/mutations/useMutationDownloadPayeeW9";
import { getIsDomesticMember } from "../../../../../../query/users/selectors";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementAction,
  RequirementTableCallback
} from "../../../../types";
import { getRequirementEngagementsTableCellProps } from "../../../../utils";
import { getTaxVerificationRequirementName } from "../helpers/getTaxVerificationRequirementName";
import { getTaxVerificationRequirementPayeeStatusCell } from "../helpers/getTaxVerificationRequirementPayeeStatusCell";

export const usePayeeTaxVerificationConfig = (
  _callback: RequirementTableCallback
): CellsConfig<
  IRequirementResponse,
  ContextItem,
  {
    payee?: IPayeeResponse;
  }
> => {
  const [downloadW9] = useMutationDownloadPayeeW9();

  return {
    isActionRequired: () => false,

    requirementName: getTaxVerificationRequirementName,

    nameCell: requirement => ({
      text: getTaxVerificationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.requirementType
      }),

    statusCell: getTaxVerificationRequirementPayeeStatusCell,

    toolbarActions: (requirement, context, additionalData) => {
      const actions: RequirementAction[] = [];

      const isDomesticPayee = additionalData.payee?.member
        ? getIsDomesticMember(additionalData.payee.member)
        : false;

      if (
        // requirement.dataSourceMetadata &&
        isDomesticPayee &&
        requirement.status === RequirementStatus.Complete
      ) {
        actions.push({
          label: "Download PDF",
          icon: "download",
          onClick: () => {
            if (!additionalData.payee?.payeeId) {
              return;
            }

            downloadW9({
              payeeId: additionalData.payee?.payeeId,
              filename:
                additionalData.payee?.user?.email ||
                `${toWSDateString(new Date(), "monthDayYear")}`
            });
          }
        });
      }

      return actions;
    },

    engagementsCell: getRequirementEngagementsTableCellProps
  };
};
